export const mapInternalStateToPayload = state => {
  const { competencies, language, name, department } = state

  return {
    language: language?.value,
    skills: competencies.reduce(
      (acc, { name, ...rest }) => ({ ...acc, [name]: rest[name] }),
      {},
    ),
    title: name,
    department: department?.value,
  }
}
